import React from 'react';
import PropTypes from 'prop-types';
import {
  FileDropzone,
  InputText,
  Radio,
  Textarea,
} from '@othermachines/react-form-kit';

import {
  Fieldset,
  FileDropzoneCloser,
} from '../../../Shared';

import {
  allowedFileTypesString,
  inputTheme,
  inputThemeShort,
  maxFileSize,
  radioTheme,
  textareaTheme,
} from '../../../lib';


const formName = 'Name Tags';

const defaultValues = {
  'Quantity': '',
  'Material': '',
  'Name-for-tag': '',
  'Title-for-tag': '',
  'Attachments': '',
  'Backing': '',
};

const fields = [
  'Quantity',
  'Material',
  'Name-for-tag',
  'Title-for-tag',
  'Attachments',
  'Backing',
];

const Component = ({
  submitForm: {
    control,
    formState,
    register,
    setValue,
    unregister,
    watch,
  },

}) => {

  return (
    <Fieldset legend={formName}>

      <InputText
        inputTextId='Quantity'
        inputTextName='Quantity'
        register={register}
        formState={formState}
        label='Quantity'
        theme={inputThemeShort}
      />

      <Radio
        radioId='Material'
        radioName='Material'
        legend='Material?'
        options={[
          { value: 'plastic', label: 'Plastic' },
          { value: 'metal', label: 'Metal' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />

      <InputText
        inputTextId='Name-for-tag'
        inputTextName='Name-for-tag'
        register={register}
        formState={formState}
        label='Name'
        theme={inputTheme}
      />

      <InputText
        inputTextId='Title-for-tag'
        inputTextName='Title-for-tag'
        register={register}
        formState={formState}
        label='Title'
        theme={inputTheme}
      />

      <FileDropzone
        fileId='Attachments'
        fileName='Attachments'
        label='Please attach a file of your logo, if applicable.'
        register={register}
        unregister={unregister}
        setValue={setValue}
        control={control}
        watch={watch}
        formState={formState}
        allowedExtensions={allowedFileTypesString}
        maxFileSize={maxFileSize}
      >
        <FileDropzoneCloser />
      </FileDropzone>

      <Radio
        radioId='Backing'
        radioName='Backing'
        legend='Backing'
        options={[
          { value: 'magnetic', label: 'Magnetic' },
          { value: 'pin', label: 'Pin' },
          { value: 'clutch', label: 'Clutch' },
        ]}
        register={register}
        formState={formState}
        columns={1}
        theme={radioTheme}
      />
    </Fieldset>
  );
};

Component.propTypes = {
  submitForm: PropTypes.shape({
    control: PropTypes.object.isRequired,
    formState: PropTypes.object.isRequired,
    register: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    unregister: PropTypes.func.isRequired,
    watch: PropTypes.func.isRequired,
  }).isRequired,
};

export default Component;
export { defaultValues, fields, formName };
